import type { IconSvgObject } from './types';

const Inequality02Icon: IconSvgObject = [
  ["path", { d: "M21 20H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 16H21.0001L6.69853 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Inequality02Icon;
